<script lang="ts" setup>
import { UnmanagedBusinessContentViewModel } from './unmanagedBusinessTableContentViewModel';
import { TableContentProperty, UnmanagedBusinessHeaderKey } from '../../interface/tableContentHeaders';
import TableCell from '../TableCell.vue';
import { TableContentItem } from '../../interface/tableContentItems';
import { i18n } from '@/i18n';
import RegisterUnmanagedBusinessButton from './RegisterUnmanagedBusinessButton.vue';
import { computed } from 'vue';

const t = i18n.t;

// props
const props = withDefaults(
  defineProps<{
    header: TableContentProperty;
    unmangedBusinessHeaderKey: UnmanagedBusinessHeaderKey;
    item: TableContentItem;
    headerIndex: number;
    accumulationTableContentWidth: number;
    isVariableWidth: boolean;
    isAllSelected: boolean;
    stableColumnCount: number;
    isEditing: boolean;
    isBold: boolean;
    isChecked: boolean;
    isCheckedBusinessId: boolean;
  }>(),
  {}
);

// emits
const emits = defineEmits<{
  (e: 'onClickNarrow'): void;
}>();

const unmanagedBusinessContentViewModel = new UnmanagedBusinessContentViewModel();

const textAlign = computed(() => {
  return props.header.propertyPath?.propertyType === 'number' ? 'right' : 'left';
});
</script>

<template>
  <TableCell
    :class="[unmanagedBusinessContentViewModel.isSticky(stableColumnCount, headerIndex) ? 'sticky-content' : '']"
    :style="{
      left: unmanagedBusinessContentViewModel.calcStickyDiff(stableColumnCount, headerIndex, accumulationTableContentWidth),
    }"
    class="table-cell base-table__body--fixed"
    :text-align="textAlign"
    :table-content-property="header"
    :tool-tip-value="unmanagedBusinessContentViewModel.displayOrderItem(unmangedBusinessHeaderKey, item)"
    :is-highlighted="props.isChecked || props.isCheckedBusinessId"
  >
    <template v-if="header.key === 'registerBusiness'">
      <RegisterUnmanagedBusinessButton class="register-unmanaged-business" :item="item" />
    </template>
    <template v-else>
      <span class="table-cell-content">
        {{ unmanagedBusinessContentViewModel.displayOrderItem(unmangedBusinessHeaderKey, item) }}
      </span>
    </template>
  </TableCell>
</template>

<style lang="scss" scoped>
.table-cell-content {
  font-family: Noto Sans JP;
  font-size: $fontSizeSS;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.register-unmanaged-business {
  height: fit-content;
  width: fit-content;
  font-size: $fontSizeSS;
  line-height: 12px;
  font-weight: 400;
  text-align: center;
  padding: 2px 4px;
}
</style>
